import { canonicalJson, sha256Hex } from '../reportGeneration/reportContractHash';

export interface SedTerminalFailureProofV1 {
  schema: 'sed-terminal-failure-v1';
  ownerUid: string;
  siteId: string;
  idempotencyKey: string;
  attemptCount: number;
  startedAt: string;
  completedAt: string;
  executionName: string | null;
  payloadFingerprint: string;
  jobSha256: string;
  siteSha256: string;
}

export function terminalStateHash(value: unknown): string {
  return sha256Hex(canonicalJson(value));
}

export function parseSedTerminalFailureProof(value: unknown): SedTerminalFailureProofV1 | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const row = value as Record<string, unknown>;
  if (row.schema !== 'sed-terminal-failure-v1'
    || !['ownerUid', 'siteId', 'idempotencyKey', 'payloadFingerprint'].every(
      (key) => typeof row[key] === 'string' && row[key].length > 0)
    || !Number.isSafeInteger(row.attemptCount) || Number(row.attemptCount) < 1
    || typeof row.startedAt !== 'string' || !Number.isFinite(Date.parse(row.startedAt))
    || typeof row.completedAt !== 'string' || !Number.isFinite(Date.parse(row.completedAt))
    || Date.parse(row.completedAt) < Date.parse(row.startedAt)
    || !(row.executionName === null || (typeof row.executionName === 'string' && row.executionName.length > 0))
    || !['jobSha256', 'siteSha256'].every((key) => typeof row[key] === 'string' && /^[0-9a-f]{64}$/.test(row[key]))) return null;
  return {
    schema: 'sed-terminal-failure-v1', ownerUid: String(row.ownerUid), siteId: String(row.siteId),
    idempotencyKey: String(row.idempotencyKey), attemptCount: Number(row.attemptCount),
    startedAt: row.startedAt, completedAt: row.completedAt, executionName: row.executionName,
    payloadFingerprint: String(row.payloadFingerprint), jobSha256: String(row.jobSha256), siteSha256: String(row.siteSha256),
  };
}

/** The proof is server-issued; the server revalidates it again at rollback commit. */
export class ConfirmedSedBootstrapFailure extends Error {
  constructor(message: string, readonly terminalFailure: SedTerminalFailureProofV1) {
    super(message);
    this.name = 'ConfirmedSedBootstrapFailure';
  }
}
